export const bboxByCode = {
    "1507": [
        5.874964375000047,
        51.37804936200007,
        6.178977731000032,
        51.52477653500006
    ],
    "1509": [
        6.289694320000024,
        51.82726290200003,
        6.532829511000045,
        51.978218878000064
    ],
    "1525": [
        4.455648009000072,
        52.17969515200008,
        4.56170409200007,
        52.25506778600004
    ],
    "1581": [
        5.246989375000055,
        51.97073015600006,
        5.529381003000026,
        52.08656793500006
    ],
    "1586": [
        6.459187535000069,
        51.96254717800008,
        6.6879811020000375,
        52.068040186000076
    ],
    "1598": [
        4.862698710000075,
        52.59528580500006,
        5.039041819000033,
        52.699909716000036
    ],
    "1621": [
        4.424221402000057,
        51.960286488000065,
        4.565200996000044,
        52.06174133500008
    ],
    "1640": [
        5.745640049000031,
        51.15130331900008,
        6.011012426000036,
        51.31657705300006
    ],
    "1641": [
        5.807666768000047,
        51.09946930600006,
        5.955475340000021,
        51.21602473000007
    ],
    "1652": [
        5.651356148000048,
        51.48409568500006,
        5.852572416000044,
        51.598207940000066
    ],
    "1655": [
        4.426674702000071,
        51.54924331500007,
        4.613891679000062,
        51.63040687300003
    ],
    "1658": [
        5.473613840000041,
        51.29520192800004,
        5.6547059840000315,
        51.42245611700008
    ],
    "1659": [
        5.53308174700004,
        51.494882758000074,
        5.6860041320000505,
        51.56967816500003
    ],
    "1667": [
        5.071181326000044,
        51.310316527000055,
        5.204697585000076,
        51.432174185000065
    ],
    "1669": [
        5.913746279000065,
        51.09653074100004,
        6.180723564000061,
        51.19441344300003
    ],
    "1674": [
        4.306808154000066,
        51.451486903000045,
        4.523190788000022,
        51.56923500900007
    ],
    "1676": [
        3.678754323000021,
        51.61400147200004,
        4.196219859000053,
        51.75868492200004
    ],
    "1680": [
        6.561504919000072,
        52.86815951300008,
        6.935684972000047,
        53.09476203200006
    ],
    "1681": [
        6.724175230000071,
        52.80463456500007,
        7.045571623000058,
        52.993353736000074
    ],
    "1684": [
        5.78611064200004,
        51.669913766000036,
        5.93451757400004,
        51.75931682300006
    ],
    "1685": [
        5.576270316000034,
        51.65006132900004,
        5.742545436000057,
        51.76804579000003
    ],
    "1690": [
        6.216320478000057,
        52.61219578600003,
        6.530556483000055,
        52.79897062100008
    ],
    "1695": [
        3.6336273580000693,
        51.52235250000007,
        3.89954496200005,
        51.60518202000003
    ],
    "1696": [
        5.02129259700007,
        52.16592939000003,
        5.145769020000046,
        52.28521475900004
    ],
    "1699": [
        6.305274461000067,
        52.98552372900008,
        6.54008578600002,
        53.20382196600008
    ],
    "1700": [
        6.447463414000026,
        52.38365887100008,
        6.717707653000048,
        52.49498134800007
    ],
    "1701": [
        6.119820037000068,
        52.72930744800004,
        6.4800258540000755,
        52.92764147100007
    ],
    "1702": [
        5.747675180000044,
        51.562643603000026,
        5.949798362000024,
        51.67996966900006
    ],
    "1705": [
        5.856873936000056,
        51.854448544000036,
        6.0462846760000275,
        51.96041548900007
    ],
    "1706": [
        5.515772315000049,
        51.220908816000076,
        5.672109257000045,
        51.35387687800005
    ],
    "1708": [
        5.795177998000042,
        52.641430670000034,
        6.20173113200002,
        52.854215355000065
    ],
    "1709": [
        4.368258729000047,
        51.606750645000034,
        4.709878893000052,
        51.71906749500005
    ],
    "1711": [
        5.795104873000071,
        51.028338175000044,
        6.036460942000076,
        51.135961587000054
    ],
    "1714": [
        3.3583810740000217,
        51.241493071000036,
        3.7124096570000233,
        51.40761504100004
    ],
    "1719": [
        4.645136409000031,
        51.62886266400005,
        4.853125197000054,
        51.76656864800003
    ],
    "1721": [
        5.423388787000022,
        51.62668564300003,
        5.6006047510000485,
        51.74060677300008
    ],
    "1723": [
        4.746994678000021,
        51.45679030700006,
        5.0166718060000335,
        51.55726963300003
    ],
    "1724": [
        5.225971662000063,
        51.261352972000054,
        5.433921267000073,
        51.38390467900007
    ],
    "1728": [
        5.183203150000054,
        51.30566482900008,
        5.313649053000063,
        51.436500454000054
    ],
    "1729": [
        5.8194083610000575,
        50.75036639400008,
        5.983516920000056,
        50.84888852700004
    ],
    "1730": [
        6.480300211000042,
        53.02578007800008,
        6.776509322000038,
        53.19830900300008
    ],
    "1731": [
        6.359556865000059,
        52.73569003000006,
        6.728628792000052,
        53.005406324000035
    ],
    "1734": [
        5.6463295120000225,
        51.87026494200006,
        5.898034277000022,
        51.97364277100007
    ],
    "1735": [
        6.416313377000051,
        52.16316640600007,
        6.752960225000038,
        52.30866579000008
    ],
    "1740": [
        5.453383859000041,
        51.88900869100007,
        5.711021480000056,
        51.954001120000044
    ],
    "1742": [
        6.326529553000057,
        52.24216608900008,
        6.5540087520000725,
        52.326462277000076
    ],
    "1771": [
        5.525201426000024,
        51.40313601200006,
        5.6565086190000216,
        51.46050863600004
    ],
    "1773": [
        6.066083949000074,
        52.29765064500003,
        6.235842797000032,
        52.453541392000034
    ],
    "1774": [
        6.759035978000043,
        52.27296136600006,
        7.07220661100007,
        52.46976751300008
    ],
    "1783": [
        4.124988071000075,
        51.94138332000006,
        4.309819301000061,
        52.058564260000026
    ],
    "1842": [
        4.233583046000035,
        51.92123637700007,
        4.403037831000063,
        52.01991686500003
    ],
    "1859": [
        6.4005393490000415,
        52.02060084500005,
        6.76057271600007,
        52.182487894000076
    ],
    "1876": [
        6.110812969000051,
        51.96797877600005,
        6.475773545000038,
        52.137712401000044
    ],
    "1883": [
        5.758000153000069,
        50.94639837100004,
        5.905515220000041,
        51.07260948900006
    ],
    "1884": [
        4.53815320700005,
        52.15224868800004,
        4.72970291300004,
        52.23381394300003
    ],
    "1891": [
        5.882245179000051,
        53.22769830900006,
        6.07775300000003,
        53.32563077200007
    ],
    "1892": [
        4.546338776000027,
        51.93349204400005,
        4.688683913000034,
        52.06553610700007
    ],
    "1894": [
        5.832074190000071,
        51.26575855500005,
        6.123251994000043,
        51.39572862000006
    ],
    "1895": [
        6.9032995880000385,
        53.11083275500005,
        7.227498050000065,
        53.26711372300008
    ],
    "1896": [
        5.971342783000068,
        52.55184088100003,
        6.166814572000021,
        52.66793727600003
    ],
    "1900": [
        5.165558632000057,
        52.84811156000006,
        5.788229573000024,
        53.15381486000007
    ],
    "1901": [
        4.659967254000037,
        52.01324223800003,
        4.8732007270000395,
        52.12228793000003
    ],
    "1903": [
        5.681970006000029,
        50.754763653000055,
        5.8641342630000395,
        50.855290480000065
    ],
    "1904": [
        4.909638083000061,
        52.116716144000065,
        5.120528828000033,
        52.28932045600004
    ],
    "1911": [
        4.7588541530000725,
        52.70680594600003,
        5.167395207000027,
        53.000092763000055
    ],
    "1916": [
        4.3352131350000604,
        52.056255081000074,
        4.493017894000047,
        52.12898037600007
    ],
    "1924": [
        3.839021803000037,
        51.65446273100008,
        4.406881621000025,
        51.84991920200008
    ],
    "1926": [
        4.372640345000036,
        51.96819870600007,
        4.476789800000063,
        52.05405417900005
    ],
    "1930": [
        4.185273239000026,
        51.78277193500003,
        4.432482636000032,
        51.87298602100003
    ],
    "1931": [
        4.576329107000049,
        51.889354182000034,
        4.877792636000038,
        52.02227216600005
    ],
    "1940": [
        5.4261024430000475,
        52.80369181900005,
        5.937847029000068,
        53.05884003500006
    ],
    "1942": [
        5.0127928300000235,
        52.25579626000007,
        5.230351191000068,
        52.365572522000036
    ],
    "1945": [
        5.879066463000072,
        51.74102787500004,
        6.0634856080000645,
        51.881671408000045
    ],
    "1948": [
        5.370946595000021,
        51.52129583700008,
        5.656554528000072,
        51.655702363000046
    ],
    "1949": [
        5.437333050000063,
        53.12414978400005,
        5.7493020470000715,
        53.338900866000074
    ],
    "1950": [
        7.014799327000048,
        52.838196905000075,
        7.217445762000068,
        53.16077553500003
    ],
    "1952": [
        6.639468394000062,
        53.070972995000034,
        6.965846338000063,
        53.29835343700006
    ],
    "1954": [
        5.796555321000028,
        50.88064796900005,
        6.02689267300002,
        50.988416904000076
    ],
    "1955": [
        6.089514835000045,
        51.867626245000054,
        6.3322797750000746,
        51.980500161000066
    ],
    "1959": [
        4.676303957000073,
        51.71081708100007,
        5.142713528000058,
        51.828529305000075
    ],
    "1960": [
        4.993863865000037,
        51.804002585000035,
        5.415233511000054,
        51.93548255400003
    ],
    "1961": [
        4.926301061000061,
        51.85736085900004,
        5.180226036000022,
        52.003026817000034
    ],
    "1963": [
        4.227420078000023,
        51.69896193000005,
        4.631608295000035,
        51.83704633600007
    ],
    "1966": [
        6.167432080000026,
        53.24944884200005,
        6.883818751000035,
        53.55406071900006
    ],
    "1969": [
        6.175234584000066,
        53.08713554700006,
        6.51144358800002,
        53.34138207700005
    ],
    "1970": [
        5.7173777300000665,
        53.24350277700006,
        6.294361163000076,
        53.479945299000065
    ],
    "1978": [
        4.619249602000025,
        51.83199374900005,
        5.0275113430000715,
        51.95092777500008
    ],
    "9000": [
        5.69086,
        51.63267,
        5.93452,
        51.77503
    ],
    "9001": [
        4.81838,
        53.08711,
        6.39703,
        53.53971
    ],
    "9002": [
        4.747,
        51.39369,
        5.01667,
        51.61629
    ],
    "9003": [
        5.07118,
        51.26135,
        5.43392,
        51.55282
    ],
    "9004": [
        5.24618,
        51.54349,
        5.45687,
        51.7015
    ],
    "9005": [
        5.060428205379767,
        52.24952707085864,
        6.01730144117532,
        52.84398224871387
    ],
    "9006": [
        5.566045382853948,
        50.750367484696426,
        6.226769353796719,
        51.778627291912755
    ],
    "9007": [
        4.190124167488729,
        51.220909401802416,
        6.048120780938219,
        51.830750955946904
    ],
    "9008": [
        6.119819962534502,
        52.6121955206128,
        7.092739745839745,
        53.20383229261856
    ],
    "9009": [
        4.993854744551292,
        51.73358070475124,
        6.832801702827627,
        52.52202502557984
    ],
    "9010": [
        4.477649500525647,
        52.16592898899302,
        5.37725983726796,
        53.21427480059697
    ],
    "9011": [
        4.792040368407709,
        51.85736068241161,
        5.627314537224701,
        52.303677037223906
    ],
    "9012": [
        5.777750068127078,
        52.118069494785125,
        7.072763362145606,
        52.85421495197515
    ],
    "9013": [
        3.307952615747958,
        51.20016211275375,
        4.277423168802465,
        51.78152048213048
    ],
    "9014": [
        3.773675409461632,
        51.64377788232158,
        5.031415074191863,
        52.33251094784661
    ],
    "9015": [
        4.818375780076682,
        52.764805208777425,
        6.427614782917278,
        53.53971343049705
    ],
    "9016": [
        6.16743182005068,
        52.83819614756878,
        7.227498451308611,
        53.57642328662697
    ],
    "9017": [
        4.38323,
        51.82985,
        4.64733,
        51.90303
    ],
    "gent": [
        3.579775,
        50.979539,
        3.849341,
        51.18888
    ],
    "0614": [
        3.992015322000043,
        51.84540307600008,
        4.160349669000027,
        51.93614153500005
    ],
    "0279": [
        5.459242748000065,
        52.069656475000045,
        5.539160163000076,
        52.111097534000066
    ],
    "0160": [
        6.303063706000046,
        52.46560403400008,
        6.766692883000076,
        52.67404934000007
    ],
    "0327": [
        5.31091955200003,
        52.08933381000003,
        5.514079540000068,
        52.161513788000036
    ],
    "0373": [
        4.609822706000045,
        52.57370026600006,
        4.752463465000062,
        52.75659493400008
    ],
    "0518": [
        4.19066341100006,
        52.01484858600003,
        4.422489330000076,
        52.12835550300008
    ],
    "0180": [
        6.095917467000049,
        52.58124643900004,
        6.3292768890000275,
        52.692183948000036
    ],
    "0439": [
        4.920650180000052,
        52.47034874000008,
        5.024699062000025,
        52.52911085000005
    ],
    "0277": [
        5.937098830000025,
        51.999637747000065,
        6.008992657000022,
        52.07916439200005
    ],
    "0523": [
        4.803378069000075,
        51.816471568000054,
        4.926985829000046,
        51.860734543000035
    ],
    "0358": [
        4.670292838000023,
        52.21635429300005,
        4.823860558000035,
        52.30577643200007
    ],
    "0575": [
        4.404876642000033,
        52.20735608500007,
        4.563707248000071,
        52.32823698700008
    ],
    "0448": [
        4.661325111000053,
        52.95957374500006,
        4.908350814000073,
        53.18517269600005
    ],
    "0289": [
        5.6058237990000634,
        51.93640539000006,
        5.72436269800005,
        52.00070797300003
    ],
    "0820": [
        5.505408386000056,
        51.433911367000064,
        5.605230837000022,
        51.53807547100007
    ],
    "0158": [
        6.6243623070000694,
        52.118069338000055,
        6.88975158300002,
        52.206331273000046
    ],
    "0307": [
        5.3064583820000735,
        52.10838471100004,
        5.484317545000067,
        52.21915466300004
    ],
    "0225": [
        5.530982351000034,
        51.83627381700006,
        5.685013790000028,
        51.90180345700003
    ],
    "0222": [
        6.144688894000069,
        51.92278210600006,
        6.416082416000052,
        51.99426084400005
    ],
    "0599": [
        3.9601425630000335,
        51.84211872000003,
        4.601807909000058,
        52.00177563700004
    ],
    "0840": [
        4.485405424000021,
        51.47331246200008,
        4.640109806000055,
        51.56856203700005
    ],
    "0756": [
        5.855796775000044,
        51.55203023400003,
        6.0481192530000385,
        51.71613964200003
    ],
    "0362": [
        4.794545938000056,
        52.24186953700007,
        4.90915067100002,
        52.33057009800007
    ],
    "0824": [
        5.130195391000029,
        51.507408561000034,
        5.277552385000035,
        51.601750579000054
    ],
    "0503": [
        4.320217770000056,
        51.966316412000026,
        4.407910772000037,
        52.03259905300007
    ],
    "0664": [
        3.7055379150000363,
        51.47912152200007,
        3.971383228000036,
        51.553417412000044
    ],
    "0118": [
        6.403637786000047,
        52.65450748400008,
        6.632413322000048,
        52.80055695400006
    ],
    "0313": [
        5.310459234000064,
        52.20552850100006,
        5.403519355000071,
        52.273538907000045
    ],
    "0093": [
        5.121145057000035,
        53.24934990600008,
        5.603148345000022,
        53.444771065000054
    ],
    "0383": [
        4.598184333000063,
        52.52672833300005,
        4.781621846000064,
        52.592585357000075
    ],
    "0252": [
        5.72974471200007,
        51.752100238000025,
        5.893408414000021,
        51.810092636000036
    ],
    "0880": [
        4.7887078460000225,
        52.468469593000066,
        4.934723413000029,
        52.54268992600004
    ],
    "0437": [
        4.870121492000067,
        52.250743112000066,
        4.955239686000027,
        52.33863836200004
    ],
    "0889": [
        6.005283190000057,
        51.24255961000006,
        6.1247561490000635,
        51.29745404800008
    ],
    "0163": [
        6.333501715000068,
        52.31821845800005,
        6.5981484910000745,
        52.46170289500003
    ],
    "0770": [
        5.237596948000032,
        51.31823719700003,
        5.388905820000048,
        51.46853650200006
    ],
    "0171": [
        5.593222320000052,
        52.60960073600006,
        6.011165657000049,
        52.84398268600006
    ],
    "0397": [
        4.5901858600000764,
        52.32220477700008,
        4.6410331710000605,
        52.363404899000045
    ],
    "0088": [
        6.057722032000072,
        53.45769629900008,
        6.391556453000021,
        53.51816872900008
    ],
    "0797": [
        5.08176006900004,
        51.635360208000066,
        5.251602433000073,
        51.74309151300008
    ],
    "0866": [
        5.417444707000072,
        51.36601274000003,
        5.516416524000022,
        51.40534933300006
    ],
    "0361": [
        4.708274422000045,
        52.519164671000055,
        4.926923799000065,
        52.68246918700004
    ],
    "0858": [
        5.387802381000029,
        51.26228528200005,
        5.527179377000039,
        51.37833514600004
    ],
    "0946": [
        5.643994989000021,
        51.23692393500005,
        5.8778217020000625,
        51.34687656700004
    ],
    "0965": [
        5.953251369000043,
        50.80146284700004,
        6.025027675000047,
        50.860226864000026
    ],
    "0431": [
        4.842950377000022,
        52.42448997100007,
        4.906468973000074,
        52.47982687900003
    ],
    "0014": [
        6.46274646300003,
        53.10620327700008,
        6.772527255000057,
        53.31296451000003
    ],
    "0473": [
        4.493822444000045,
        52.31399673400006,
        4.591658735000067,
        52.40142304200003
    ],
    "0275": [
        5.951526319000038,
        51.97440593200008,
        6.137469349000071,
        52.08824598400008
    ],
    "0498": [
        5.091751609000028,
        52.619595642000036,
        5.247083112000041,
        52.70745172800008
    ],
    "0010": [
        6.777166513000054,
        53.23695368600005,
        7.099480050000068,
        53.422419535000074
    ],
    "0189": [
        6.468189464000034,
        52.26911606800007,
        6.63178285500004,
        52.417514149000056
    ],
    "0302": [
        5.678922643000021,
        52.26714594200007,
        5.880951889000073,
        52.40677125700006
    ],
    "0753": [
        5.34940031900004,
        51.471756120000066,
        5.447506191000059,
        51.54835296400006
    ],
    "0717": [
        3.4333755490000613,
        51.46304811600004,
        3.7319902110000385,
        51.65033123300003
    ],
    "0420": [
        4.971887238000022,
        52.66442024200006,
        5.272245614000042,
        52.77482165600003
    ],
    "0244": [
        6.000789547000068,
        52.44376592000003,
        6.103546903000051,
        52.50960661000005
    ],
    "0168": [
        6.934326401000021,
        52.22073687100004,
        7.07276521600005,
        52.37986014400008
    ],
    "0632": [
        4.792079958000045,
        52.064950717000045,
        5.005010983000034,
        52.16205130600008
    ],
    "0718": [
        3.38022645500007,
        51.37993375900004,
        3.7180543450000414,
        51.48227945800005
    ],
    "0296": [
        5.597976079000034,
        51.77285085400007,
        5.80094798500005,
        51.86743893900007
    ],
    "0513": [
        4.6594538540000485,
        51.99625845400004,
        4.757329994000031,
        52.04012023400003
    ],
    "0175": [
        6.323412497000049,
        52.42814481200003,
        6.609644637000031,
        52.592584317000046
    ],
    "0197": [
        6.464335135000056,
        51.853823411000064,
        6.6687330660000725,
        51.974368457000026
    ],
    "0512": [
        4.921687378000058,
        51.81885693100003,
        5.031414086000041,
        51.86362933200007
    ],
    "0269": [
        5.841432255000029,
        52.39139310000007,
        6.03694581600007,
        52.522025083000074
    ],
    "0893": [
        5.9766057490000435,
        51.50308065400003,
        6.213359463000074,
        51.67616447800003
    ],
    "0762": [
        5.717185738000069,
        51.35253442000004,
        5.931285679000041,
        51.50414393300008
    ],
    "0779": [
        4.823609654000052,
        51.67183561600007,
        4.9331687770000485,
        51.720149046000074
    ],
    "0629": [
        4.3028621240000575,
        52.09477304300003,
        4.443939270000044,
        52.187001732000056
    ],
    "0003": [
        6.803338195000038,
        53.290127006000034,
        6.8881603210000435,
        53.34735129100005
    ],
    "0308": [
        5.212075389000063,
        52.16538009800007,
        5.335785258000044,
        52.23282961000007
    ],
    "0542": [
        4.549238909000053,
        51.90236716900006,
        4.643019601000049,
        51.93104989700004
    ],
    "0202": [
        5.802960596000048,
        51.93346388100008,
        5.990340119000052,
        52.07789081400006
    ],
    "0845": [
        5.303796526000042,
        51.600223662000076,
        5.456871844000034,
        51.701484322000056
    ],
    "0917": [
        5.895424227000035,
        50.818402294000066,
        6.026378127000044,
        50.93661202100003
    ],
    "0638": [
        4.470825840000032,
        52.080510910000044,
        4.55073285900005,
        52.14739831600008
    ],
    "0335": [
        4.868225435000056,
        52.01001414700005,
        5.0180102220000435,
        52.079920687000026
    ],
    "0537": [
        4.374137355000073,
        52.15565354700004,
        4.466507755000066,
        52.21994410700006
    ],
    "0263": [
        5.173672103000058,
        51.73358050500008,
        5.41622237200005,
        51.83765863200006
    ],
    "0344": [
        4.970095929000024,
        52.02628215500005,
        5.195154392000063,
        52.142050968000035
    ],
    "0457": [
        5.0172722690000455,
        52.27798833400004,
        5.1076738690000525,
        52.33086839500004
    ],
    "0530": [
        4.048473756000021,
        51.803752548000034,
        4.222271735000049,
        51.88160350900006
    ],
    "0209": [
        5.667852395000068,
        51.83229104700007,
        5.825694855000052,
        51.89567154100007
    ],
    "0060": [
        5.61291004900005,
        53.42389217400006,
        5.967733559000067,
        53.47145470600003
    ],
    "0090": [
        5.870313018000047,
        53.070786035000026,
        6.1857164680000665,
        53.159504894000065
    ],
    "0758": [
        4.657988519000071,
        51.48554828400006,
        4.871683908000023,
        51.64319815300007
    ],
    "0268": [
        5.757619981000062,
        51.79058871600006,
        5.908346240000071,
        51.89462044700008
    ],
    "0233": [
        5.547734717000026,
        52.23932542600005,
        5.761449441000025,
        52.32838224100004
    ],
    "0484": [
        4.530103262000068,
        52.05856956200006,
        4.760075566000069,
        52.16750459800005
    ],
    "0668": [
        5.400632671000039,
        51.809535819000075,
        5.609857026000043,
        51.89475319300004
    ],
    "0589": [
        4.798701037000058,
        51.98614305000007,
        4.926681164000058,
        52.06344679000006
    ],
    "0796": [
        5.206494055000064,
        51.663996428000075,
        5.499655389000054,
        51.765030169000056
    ],
    "0451": [
        4.723660061000032,
        52.20651686000008,
        4.852187615000048,
        52.26101605400004
    ],
    "0345": [
        5.512591841000074,
        51.99695825200007,
        5.590241939000066,
        52.049373253000056
    ],
    "0716": [
        3.98341752500005,
        51.48766975900003,
        4.23628689100002,
        51.65386451100005
    ],
    "0293": [
        5.949249382000062,
        51.93867508900007,
        6.003187972000035,
        51.98064984700005
    ],
    "0553": [
        4.513522587000068,
        52.22220589300008,
        4.572748600000068,
        52.28664440500006
    ],
    "0342": [
        5.24317247700003,
        52.110271785000066,
        5.349925610000071,
        52.204535848000035
    ],
    "0024": [
        6.592582681000067,
        53.28308744100008,
        6.838919765000071,
        53.41086468700007
    ],
    "0321": [
        5.119562834000021,
        51.95946497500006,
        5.2714461410000695,
        52.056757223000034
    ],
    "0214": [
        5.241920934000063,
        51.873396738000054,
        5.586616549000041,
        51.98594749200004
    ],
    "0453": [
        4.531881819000034,
        52.41082016300004,
        4.7219825440000704,
        52.48944670800006
    ],
    "0826": [
        4.78107088400003,
        51.57844199200008,
        4.934409694000067,
        51.68601763600003
    ],
    "0072": [
        5.200523944000054,
        53.020086279000054,
        5.496392699000069,
        53.20987310700008
    ],
    "0489": [
        4.479871849000062,
        51.82985416900004,
        4.5714128350000465,
        51.87402716300005
    ],
    "0737": [
        5.829643479000026,
        53.12160855800005,
        6.11459295700007,
        53.28864985700005
    ],
    "0744": [
        4.766568968000058,
        51.39368698900006,
        5.010991716000035,
        51.480929598000046
    ],
    "0957": [
        5.916650465000032,
        51.158752152000034,
        6.086023202000035,
        51.258682484000076
    ],
    "0606": [
        4.3506710950000524,
        51.89668790700006,
        4.417712727000037,
        51.963406700000064
    ],
    "0177": [
        6.144146549000027,
        52.30052117900004,
        6.405169864000072,
        52.47438869900003
    ],
    "0798": [
        5.048791117000064,
        51.428240146000064,
        5.251248869000051,
        51.54591883000006
    ],
    "0678": [
        3.9077429480000205,
        51.448147608000056,
        4.017376211000055,
        51.529959854000026
    ],
    "0221": [
        6.109590871000023,
        51.995565932000034,
        6.177295910000055,
        52.042096893000064
    ],
    "0627": [
        4.591088827000021,
        52.01168030300005,
        4.706038987000056,
        52.07704988800003
    ],
    "0106": [
        6.483948001000044,
        52.93251576700004,
        6.632644636000066,
        53.06192164700008
    ],
    "0213": [
        6.006084935000047,
        52.059180903000026,
        6.218380785000022,
        52.16205959300004
    ],
    "0944": [
        5.864468023000029,
        51.71767075400004,
        5.938297546000058,
        51.77862666800007
    ],
    "0888": [
        5.754764286000068,
        50.89856725300007,
        5.856927810000059,
        50.955143304000046
    ],
    "0416": [
        4.728852619000065,
        52.64835511800004,
        4.833766213000047,
        52.731347363000054
    ],
    "0637": [
        4.415230587000053,
        52.03128072900006,
        4.55768594400007,
        52.093290581000076
    ],
    "0363": [
        4.728758231000029,
        52.27817457500004,
        5.068595450000032,
        52.43106396500008
    ],
    "0938": [
        5.712474350000036,
        50.86597238300004,
        5.803478447000032,
        50.94341101300006
    ],
    "0339": [
        5.495558589000041,
        52.03946875300005,
        5.5627392320000695,
        52.10541973900007
    ],
    "0879": [
        4.529895547000024,
        51.42201468800005,
        4.744059295000056,
        51.54979863700004
    ],
    "0164": [
        6.702039730000024,
        52.191064597000036,
        6.852528320000033,
        52.313585826000065
    ],
    "0274": [
        5.713608349000026,
        51.95899583800008,
        5.870860221000044,
        52.02407046700006
    ],
    "0392": [
        4.599520061000021,
        52.33890625500004,
        4.686920479000037,
        52.42856964600003
    ],
    "0687": [
        3.575298273000044,
        51.46814983300004,
        3.746944961000054,
        51.53530371200003
    ],
    "0352": [
        5.242354662000025,
        51.954919191000045,
        5.41527684600004,
        52.027001778000056
    ],
    "0501": [
        4.135295964000022,
        51.84970769900008,
        4.239383615000065,
        51.93140940100005
    ],
    "0059": [
        6.019790687000068,
        53.14499385800008,
        6.235100831000068,
        53.27003677600004
    ],
    "0203": [
        5.472433580000029,
        52.10049439900007,
        5.811932674000047,
        52.24250332400004
    ],
    "0622": [
        4.2675710770000705,
        51.89404035100006,
        4.370622440000034,
        51.95150660000007
    ],
    "0907": [
        5.919468535000021,
        51.64378237100004,
        6.044937894000043,
        51.74802340800005
    ],
    "0166": [
        5.799859351000066,
        52.474057652000056,
        6.033038684000076,
        52.62522599300007
    ],
    "0935": [
        5.638863870000023,
        50.803804581000065,
        5.762923089000026,
        50.91200280900006
    ],
    "0396": [
        4.586491956000032,
        52.48633262100003,
        4.720366622000029,
        52.53176359300005
    ],
    "0823": [
        5.191024262000042,
        51.42508268500006,
        5.391185405000044,
        51.552820678000046
    ],
    "0867": [
        4.917990290000034,
        51.65153186400005,
        5.111506039000062,
        51.723061941000026
    ],
    "0114": [
        6.826360769000075,
        52.632705643000065,
        7.0927395060000435,
        52.87301191900008
    ],
    "0230": [
        5.757020776000047,
        52.35787298400004,
        5.924339277000058,
        52.47072487500003
    ],
    "0777": [
        4.590425656000036,
        51.51720528000004,
        4.694624293000061,
        51.63474890900005
    ],
    "0703": [
        3.9928585340000495,
        51.37477458700005,
        4.277425009000069,
        51.518447981000065
    ],
    "0603": [
        4.290951749000044,
        52.012793489000046,
        4.357830165000053,
        52.06180630000006
    ],
    "0873": [
        4.263732421000043,
        51.35435180800005,
        4.431691295000064,
        51.46680068500007
    ],
    "0417": [
        5.188852771000029,
        52.21212942500006,
        5.245093116000021,
        52.272909337000044
    ],
    "0226": [
        5.965775476000033,
        51.91233353400003,
        6.068852750000076,
        51.98185912900004
    ],
    "0986": [
        5.861489024000036,
        50.83965878200007,
        5.969360906000077,
        50.90484374000005
    ],
    "0677": [
        3.941755166000064,
        51.24111394200003,
        4.235267582000063,
        51.406654083000035
    ],
    "0370": [
        4.833909515000073,
        52.510807544000045,
        4.997163628000067,
        52.61410231600007
    ],
    "0546": [
        4.4388650340000595,
        52.11895204000007,
        4.524037544000066,
        52.18460632300008
    ],
    "0331": [
        4.834114773000067,
        51.938030352000055,
        5.062637862000031,
        52.02562726200006
    ],
    "0626": [
        4.4011589690000505,
        52.10147064800003,
        4.469298688000038,
        52.149878382000054
    ],
    "0183": [
        6.669673820000071,
        52.32966519300004,
        6.94922506100005,
        52.478131940000026
    ],
    "0479": [
        4.674847587000045,
        52.41666237600003,
        4.862804385000061,
        52.52123736500005
    ],
    "0034": [
        5.121612808000066,
        52.303146937000065,
        5.379211215000055,
        52.43594924100006
    ],
    "0098": [
        5.818128778000073,
        52.800728020000065,
        6.247258595000062,
        52.943014074000075
    ],
    "0086": [
        5.927580968000029,
        52.96436426200006,
        6.332056162000072,
        53.12921393700003
    ],
    "0193": [
        6.003620310000031,
        52.440531115000056,
        6.210810843000047,
        52.58794054300006
    ],
    "0981": [
        5.920540147000054,
        50.75275892800005,
        6.027929601000039,
        50.80343934700005
    ],
    "0273": [
        5.474192767000034,
        52.20233694400008,
        5.683642684000063,
        52.291988719000074
    ],
    "0415": [
        4.893076790000066,
        52.41160772100005,
        4.950878532000047,
        52.49043490500003
    ],
    "0085": [
        6.084847842000045,
        52.90635648300008,
        6.427615260000039,
        53.07527995800007
    ],
    "0153": [
        6.755893443000048,
        52.16120538200005,
        6.98110144900005,
        52.28550545300004
    ],
    "0399": [
        4.670644030000062,
        52.57873769100007,
        4.752137387000062,
        52.625026225000056
    ],
    "0482": [
        4.626391764000061,
        51.838650458000075,
        4.700239851000049,
        51.881211817000064
    ],
    "0148": [
        6.162496152000074,
        52.424440986000036,
        6.384150269000031,
        52.599171299000034
    ],
    "0547": [
        4.514698982000027,
        52.13190362900008,
        4.5714805470000215,
        52.18211680100006
    ],
    "0441": [
        4.646052283000074,
        52.69140457100008,
        4.850373314000024,
        52.88358834600007
    ],
    "0983": [
        6.071778637000023,
        51.27706068800006,
        6.226767556000027,
        51.507816657000035
    ],
    "0597": [
        4.549253867000061,
        51.83873011500003,
        4.647331178000059,
        51.903031465000026
    ],
    "0865": [
        5.2022519280000665,
        51.61919662000008,
        5.321189962000062,
        51.69003055400003
    ],
    "0394": [
        4.550459162000038,
        52.21446882300006,
        4.81914690800005,
        52.433336276000034
    ],
    "0037": [
        6.861287485000048,
        52.91903769700008,
        7.100076109000042,
        53.073703185000056
    ],
    "0228": [
        5.5467448320000585,
        51.99095116900003,
        5.951465909000035,
        52.15222871000003
    ],
    "0246": [
        5.951005523000049,
        52.356512603000056,
        6.130553966000036,
        52.45480687400004
    ],
    "0301": [
        6.140442243000052,
        52.08874347300008,
        6.328314591000037,
        52.16980138500003
    ],
    "0243": [
        5.576000213000043,
        52.301492662000044,
        5.712844324000059,
        52.37884155000006
    ],
    "0351": [
        5.298300390000065,
        52.04312327100007,
        5.497875719000035,
        52.11742649900003
    ],
    "0784": [
        4.829084098000067,
        51.51008124600003,
        4.97956453200004,
        51.61629457600003
    ],
    "0766": [
        4.9042786020000335,
        51.607092925000075,
        5.004496037000024,
        51.67891574400005
    ],
    "0384": [
        4.942692759000067,
        52.31397908400004,
        5.034576851000054,
        52.35610177400008
    ],
    "0788": [
        5.1448523140000475,
        51.58555704100007,
        5.316486964000035,
        51.66982183300007
    ],
    "0882": [
        5.990625594000051,
        50.87021919500006,
        6.094157302000042,
        50.934701105000045
    ],
    "0654": [
        3.6956798180000305,
        51.38535204100003,
        3.9340815910000515,
        51.50245625600007
    ],
    "0173": [
        6.8598184050000555,
        52.28216783600004,
        6.950390796000022,
        52.33346022300003
    ],
    "0579": [
        4.434946384000057,
        52.162052524000046,
        4.497569947000045,
        52.20479945500006
    ],
    "0815": [
        5.699959457000034,
        51.63266758700007,
        5.842804174000037,
        51.72641480200008
    ],
    "0590": [
        4.66917888100005,
        51.82039653100003,
        4.743493858000022,
        51.849093313000026
    ],
    "0406": [
        5.184702710000067,
        52.26711554900004,
        5.2882440390000625,
        52.31375091500007
    ],
    "0450": [
        4.6904958550000515,
        52.49495415000007,
        4.782475780000027,
        52.55164294000008
    ],
    "0851": [
        4.190124313000069,
        51.54372131900004,
        4.443998803000056,
        51.65841775500007
    ],
    "0385": [
        4.949344379000024,
        52.48456845700008,
        5.0860339720000525,
        52.612446860000034
    ],
    "0119": [
        6.1200647030000255,
        52.667988395000066,
        6.286682937000023,
        52.77305466000007
    ],
    "0096": [
        4.845766982000043,
        53.204623781000066,
        5.160028638000028,
        53.308016105000036
    ],
    "0312": [
        5.153030157000046,
        51.99774785900007,
        5.280152858000065,
        52.08056246900003
    ],
    "0262": [
        6.156082492000053,
        52.096907876000046,
        6.494372750000025,
        52.246112485000026
    ],
    "0743": [
        5.693982886000072,
        51.333804248000035,
        5.87035794600007,
        51.440065161000064
    ],
    "0856": [
        5.561965244000021,
        51.62249600400003,
        5.750477309000075,
        51.70352634200003
    ],
    "0569": [
        4.681208740000045,
        52.106507942000064,
        4.892272753000043,
        52.22874173400004
    ],
    "0150": [
        6.1013210360000585,
        52.217440768000074,
        6.381893762000061,
        52.32112189000003
    ],
    "0184": [
        5.591107306000026,
        52.63744469400007,
        5.655380583000067,
        52.68332006800006
    ],
    "0971": [
        5.719628567000029,
        50.92792794600007,
        5.789245097000048,
        51.01916637800008
    ],
    "0786": [
        5.690857522000044,
        51.71797835500007,
        5.7997481830000766,
        51.77503371500006
    ],
    "0899": [
        5.928468131000045,
        50.926439145000074,
        6.0182000880000714,
        50.96250223100003
    ],
    "0828": [
        5.353513976000045,
        51.72586618100007,
        5.711229296000056,
        51.830750754000064
    ],
    "0340": [
        5.477664051000033,
        51.94312470300008,
        5.627314618000071,
        52.018516042000044
    ],
    "0232": [
        5.840831635000029,
        52.25580714500006,
        6.09485838300003,
        52.398437261000026
    ],
    "0074": [
        5.795508144000053,
        52.91174076400006,
        6.205423706000033,
        53.08519892000004
    ],
    "0984": [
        5.838237324000033,
        51.44655722400006,
        6.141092270000058,
        51.570242800000074
    ],
    "0556": [
        4.212717680000026,
        51.90533510000006,
        4.2926105990000565,
        51.94799136000006
    ],
    "0297": [
        5.000362928000072,
        51.73760682400007,
        5.28843650400006,
        51.82684810600006
    ],
    "0402": [
        5.102012801000058,
        52.17768131500003,
        5.218960265000021,
        52.285545486000046
    ],
    "0400": [
        4.709439661000033,
        52.87862686900007,
        4.8099361500000555,
        52.96556996700008
    ],
    "0141": [
        6.597705263000023,
        52.28997379100008,
        6.721168543000033,
        52.39912332500006
    ],
    "0715": [
        3.6441503670000657,
        51.20016290700005,
        4.005692882000062,
        51.36542696300006
    ],
    "0216": [
        5.142432205000034,
        51.91963008700003,
        5.27037309800005,
        51.97893981400006
    ],
    "0377": [
        4.541213219000042,
        52.309298186000035,
        4.6316471870000555,
        52.43810375800007
    ],
    "0848": [
        5.423794833000045,
        51.49392685600003,
        5.546271552000064,
        51.54184797900007
    ],
    "0398": [
        4.785277578000034,
        52.63267829800003,
        4.899882460000072,
        52.72334573100005
    ],
    "0809": [
        4.987266421000072,
        51.60568078700004,
        5.106136581000044,
        51.676834291000034
    ],
    "0299": [
        5.987062532000039,
        51.84072143700007,
        6.167912616000024,
        52.01502429100003
    ],
    "0502": [
        4.537160678000021,
        51.90620454300006,
        4.619488907000061,
        51.96550395100007
    ],
    "0736": [
        4.794430232000025,
        52.16146133700005,
        5.0218661240000415,
        52.30367731200005
    ],
    "0772": [
        5.356717116000027,
        51.40004716400006,
        5.548851890000037,
        51.497075722000034
    ],
    "0356": [
        5.06251125600005,
        51.99745196100008,
        5.1309929020000595,
        52.06224883400006
    ],
    "0861": [
        5.31580694400003,
        51.37645977300008,
        5.429854375000048,
        51.43890853900007
    ],
    "0613": [
        4.38322882500006,
        51.831645441000035,
        4.492227501000059,
        51.873198785000056
    ],
    "0355": [
        5.192751465000072,
        52.05848692700005,
        5.33260899000004,
        52.17125149600008
    ],
    "0147": [
        6.6894819860000325,
        52.28311313700004,
        6.802129671000046,
        52.341207490000045
    ],
    "0376": [
        5.2038218970000685,
        52.25466337900008,
        5.3285083420000205,
        52.30508714600006
    ],
    "0388": [
        5.217862934000038,
        52.686668617000066,
        5.307808100000045,
        52.805715692000035
    ],
    "0505": [
        4.621221582000032,
        51.717308392000064,
        4.884641732000034,
        51.82334765600007
    ],
    "0080": [
        5.631992852000053,
        53.04584995300007,
        5.949657235000075,
        53.29472214800006
    ],
    "0852": [
        4.946876474000021,
        52.415129282000066,
        5.139574018000076,
        52.49473296200006
    ],
    "0531": [
        4.600155323000024,
        51.823589362000064,
        4.672702511000068,
        51.869846695000035
    ],
    "0855": [
        4.947845801000028,
        51.52950133500008,
        5.179538499000046,
        51.64058725500007
    ],
    "0610": [
        4.729638402000035,
        51.815132848000076,
        4.811415217000047,
        51.84663997100006
    ],
    "0765": [
        6.905497766000053,
        53.01386193900004,
        7.042657714000029,
        53.11919794700003
    ],
    "0303": [
        5.565420489000076,
        52.37017855200003,
        5.857871107000051,
        52.61569429300005
    ],
    "0988": [
        5.566044028000022,
        51.18042011400007,
        5.791768538000042,
        51.29057478400006
    ],
    "0375": [
        4.580782852000027,
        52.45552045300008,
        4.707968447000042,
        52.50174414300005
    ],
    "0794": [
        5.570154941000055,
        51.438041774000055,
        5.736092840000026,
        51.50921692500003
    ],
    "0755": [
        5.626567316000035,
        51.58235984700008,
        5.758613627000045,
        51.62906063200006
    ],
    "0294": [
        6.629071225000075,
        51.896063757000036,
        6.832801320000044,
        52.04006457600008
    ],
    "0109": [
        6.576429327000028,
        52.62676060600006,
        6.861875570000052,
        52.87869199200003
    ],
    "0267": [
        5.393215514000076,
        52.16576235900004,
        5.634862354000063,
        52.26374075600006
    ],
    "0534": [
        4.542318857000055,
        52.27124035800006,
        4.611675640000044,
        52.31839522100006
    ],
    "0310": [
        5.094889735000038,
        52.08489541200004,
        5.230929917000026,
        52.20427413800007
    ],
    "0642": [
        4.553609105000021,
        51.80076028600007,
        4.671708687000034,
        51.84711673100003
    ],
    "0785": [
        4.962572124000076,
        51.471108048000076,
        5.1106446230000415,
        51.54013270400003
    ],
    "0994": [
        5.749285070000042,
        50.82954884800006,
        5.887991126000031,
        50.89220865300007
    ],
    "0050": [
        5.301243578000026,
        52.25219038100005,
        5.623022222000031,
        52.44265696700006
    ],
    "0200": [
        5.7263895750000415,
        52.073338801000034,
        6.078484435000064,
        52.28566957900006
    ],
    "0757": [
        5.246176999000056,
        51.543488368000055,
        5.4052001450000375,
        51.63463373900004
    ],
    "0317": [
        5.2229012120000675,
        52.21927418800004,
        5.331193000000042,
        52.28192665500006
    ],
    "0928": [
        6.000567122000064,
        50.84367554800008,
        6.088101207000022,
        50.90576987500003
    ],
    "0285": [
        6.024813082000037,
        52.14393835700008,
        6.194369958000038,
        52.33090746700003
    ],
    "0353": [
        4.978378952000071,
        51.99123319800003,
        5.077717281000048,
        52.061143076000064
    ],
    "0047": [
        6.801673781000034,
        53.03240787700008,
        6.961905202000025,
        53.128841081000076
    ],
    "0281": [
        5.328032280000059,
        51.85180084500007,
        5.472450295000044,
        51.92276118800004
    ],
    "0432": [
        4.898668119000035,
        52.67176568800005,
        5.0111630080000396,
        52.755296515000055
    ],
    "0995": [
        5.257817524000075,
        52.38437813100006,
        5.605871213000057,
        52.69222659800005
    ],
    "0748": [
        4.218747749000045,
        51.43966691500003,
        4.372797116000072,
        51.57066128400004
    ],
    "0405": [
        5.013535184000034,
        52.62991721900005,
        5.119413090000023,
        52.68436549200004
    ],
    "0532": [
        5.185373102000028,
        52.67761345100007,
        5.259534185000064,
        52.71769713600003
    ],
    "0847": [
        5.637854148000031,
        51.315093467000054,
        5.770447367000031,
        51.45780645700006
    ]
}